const INITIAL_STATE = {
  data: [],
  filtereddata: [],
  loading: false,
  error: false,
  allQuizzes:[],
  allQuizzesLoading: false,
  allQuizzeserror: false
};

const getadminquizresults = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_ADMIN_QUIZ":
      return { ...state, loading: true };
    case "GET_ADMIN_QUIZ_SUCCESS":
      return { ...state, loading: false, data: action.payload };
    case "GET_ADMIN_QUIZ_ERROR":
      return { ...state, loading: false, error: true };
    case 'FILTER_ADMINQUIZ':
        return {...state,loading: true, filtereddata: action.payload}
    case 'FILTER_ADMINQUIZ_SUCCESS':
        return {...state,loading: false, filtereddata: action.payload}
    case 'FILTER_ADMINQUIZ_ERROR':
        return {...state,loading: false, error: true}
    case 'GET_ALL_QUIZ_REQUEST':
        return {...state,allQuizzesLoading: true}
    case 'GET_ALL_QUIZ_REQUEST_SUCCESS':
        return {...state,allQuizzesLoading: false, allQuizzes: action.payload}
    case 'GET_ALL_QUIZ_REQUEST_ERROR':
        return {...state,allQuizzesLoading: false, error: true}
    default:
      return { ...state };
  }
};

export { getadminquizresults };

